import React, { Suspense, ReactNode } from 'react';
import { CenteredLoadingIndicator } from '@spotify-internal/anchor-ds';
import { KeyboardDetectionProvider } from '@spotify-internal/encore-web';
import { HelmetProvider } from 'react-helmet-async';
import { I18NClientProvider } from 'client/i18n/context';
import { BrowserSizeProvider } from './BrowserSize';
import { NetworkRoleProvider } from './NetworkRole';
import { UnsavedChangesWarningProvider } from './UnsavedChangesWarning';
import { FeatureFlagsProvider } from './FeatureFlags';
import { CurrentUserProvider } from './CurrentUser';
import { ExperimentationProvider } from './Experimentation';
import { ReactQueryProvider } from './ReactQuery';
import { QuickUploadFileProvider } from './QuickUploadFile';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <HelmetProvider>
      <ReactQueryProvider>
        <CurrentUserProvider>
          <ExperimentationProvider>
            <I18NClientProvider>
              <FeatureFlagsProvider>
                <UnsavedChangesWarningProvider>
                  <NetworkRoleProvider>
                    <BrowserSizeProvider>
                      <QuickUploadFileProvider>
                        <KeyboardDetectionProvider>
                          <Suspense
                            fallback={
                              <div>
                                <CenteredLoadingIndicator size="lg" />
                              </div>
                            }
                          >
                            {children}
                          </Suspense>
                        </KeyboardDetectionProvider>
                      </QuickUploadFileProvider>
                    </BrowserSizeProvider>
                  </NetworkRoleProvider>
                </UnsavedChangesWarningProvider>
              </FeatureFlagsProvider>
            </I18NClientProvider>
          </ExperimentationProvider>
        </CurrentUserProvider>
      </ReactQueryProvider>
    </HelmetProvider>
  );
}
